import React from 'react'
import { Link } from 'react-router-dom'
import { useLocale } from '../contexts/LocaleContext'
import BrandMark from './BrandMark'

const STATS = [
  { value: '500+', key: 'organizations' },
  { value: '10K+', key: 'volunteers' },
  { value: '99%', key: 'satisfaction' },
] as const

const Hero: React.FC = () => {
  const { t } = useLocale()

  return (
    <>
      <section className="mx-auto max-w-[1280px] px-5 pb-16 pt-16 text-center sm:px-8 lg:px-14 lg:pt-[88px]">
        <a
          href="#app"
          className="mb-6 inline-flex items-center gap-2 rounded-pill border border-border bg-surface-card py-1.5 pl-1.5 pr-4 text-[13px] font-semibold text-text-primary shadow-card hover:bg-surface-sunken"
        >
          <span className="rounded-pill bg-clay-500 px-2.5 py-0.5 text-text-on-primary">
            {t('apps.new')}
          </span>
          {t('apps.announcement')}
          <span aria-hidden>→</span>
        </a>
        <h1 className="mx-auto max-w-[20ch] text-balance font-display text-[36px] font-bold leading-[1.1] tracking-display sm:text-[44px] lg:text-[52px]">
          {t('hero.title')} <span className="text-clay-500">{t('hero.titleHighlight')}</span>
        </h1>
        <p className="mx-auto mt-5 max-w-[52ch] text-[17px] leading-relaxed text-text-secondary sm:text-[19px]">
          {t('hero.subtitle')}
        </p>

        <div className="mt-8 flex flex-wrap justify-center gap-3">
          <Link
            to="/signup"
            className="inline-flex min-h-touch-comfort items-center gap-2 rounded-md bg-action-primary px-7 text-[17px] font-semibold text-text-on-primary hover:bg-action-primary-hover"
          >
            {t('navigation.startFreeTrial')} <span aria-hidden>→</span>
          </Link>
          <a
            href="#prijzen"
            className="inline-flex min-h-touch-comfort items-center rounded-md border-[1.5px] border-border-strong px-7 text-[17px] font-semibold text-text-primary hover:bg-surface-sunken"
          >
            {t('navigation.viewPricing')}
          </a>
        </div>

        <div className="mt-10 flex justify-center gap-9">
          {STATS.map((stat) => (
            <div key={stat.key}>
              <div className="font-display text-[26px] font-bold">{stat.value}</div>
              <div className="text-[13px] text-text-muted">{t(`hero.stats.${stat.key}`)}</div>
            </div>
          ))}
        </div>
      </section>

      {/* A real event, with the product laid over it: proof that this is about a day
          that has to go well, not about software. */}
      <section className="relative">
        <div className="relative max-h-[640px] min-h-[320px] overflow-hidden sm:min-h-[460px]">
          <img
            src="/img/volunteers-market.png"
            alt={t('hero.photoAlt')}
            className="block max-h-[640px] min-h-[320px] w-full object-cover object-[50%_38%] sm:min-h-[460px]"
          />

          <div className="absolute left-[7%] top-9 hidden w-56 md:block">
            <div className="rounded-lg border border-border bg-surface-card p-3 shadow-overlay">
              <div className="mb-1 flex items-center justify-between">
                <span className="flex items-center gap-1.5">
                  <BrandMark size={13} />
                  <span className="font-display text-[11px] font-bold text-clay-600">
                    RallyShift
                  </span>
                </span>
                <span className="text-[11px] font-semibold text-text-muted">08:00–12:00</span>
              </div>
              <div className="text-sm font-semibold text-text-primary">
                {t('hero.checkedInShift')}
              </div>
              <div className="mt-1 inline-flex items-center gap-1.5 text-[11px] font-semibold text-status-success-text">
                <span aria-hidden className="text-[13px] text-status-success">
                  ◉
                </span>
                {t('hero.checkedInAt')}
              </div>
            </div>
          </div>

          <div className="absolute right-[8%] top-12 hidden w-56 md:block">
            <div className="rounded-lg border border-border bg-surface-card p-3 shadow-overlay">
              <span className="text-[13px] font-semibold text-text-primary">
                {t('hero.teamShift')}
              </span>
              <div className="mt-1.5">
                <div className="mb-1 flex justify-between text-[11px]">
                  <b>2 / 3</b>
                  <span className="font-semibold text-capacity-filling">
                    {t('hero.oneSpotLeft')}
                  </span>
                </div>
                <div className="h-1.5 overflow-hidden rounded-sm bg-surface-sunken">
                  <div className="h-full w-2/3 bg-capacity-filling" />
                </div>
              </div>
            </div>
          </div>

          <div className="absolute bottom-14 left-[7%] hidden sm:block lg:bottom-20">
            <span className="inline-flex items-center rounded-pill bg-surface-inverse px-5 py-2.5 text-sm font-semibold text-text-inverse shadow-overlay">
              {t('hero.caption')}
            </span>
          </div>
        </div>
      </section>
    </>
  )
}

export default Hero
